// extracted by mini-css-extract-plugin
export default {"fullWidth":"lo-z","image":"mo-z","lazyLoadPicture":"no-z","lazyLoadSpinner":"oo-z","lazyLoadSpin":"po-z","lazyLoadImage":"qo-z","hasStyledAspectRatio":"ro-z"};